export default __webpack_public_path__ + "src/images/packages/safari-moon-lodge/eb9b5ac0cbaa2aef6114871238b0f286-4.jpg";